import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=5388926c&scoped=true&"
var script = {}
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=5388926c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388926c",
  null
  
)

export default component.exports